define('views/user/register/financial/visaredirect',["backbone",
         "text!views/user/register/financial/visaredirect.html",
         "views/_base/baseview",
         "models/linkedcards/linkedcard"
], function (Backbone, Template, BaseView,  LinkedCard) {
    "use strict";

    return BaseView.extend({
        isRender: true,
        needsAuth: true,
        template: _.template(Template),
        events: {
            "click #linkVisa": "showSelectedproduct",
            "click #getDebit": "showSelectedproduct",
        },
        tagName: "section",
        id: "visaRedirect",
        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;

            var that = this;

            var card = new LinkedCard(
                {
                    NSID: enums.networkSources.Visa
                });
            $.ajax({
                type: "POST",
                url: pf.consumerURL + "/LinkedCards",
                data: JSON.stringify(card),
                async: true,
                contentType: "application/json; charset=utf-8",
                traditional: true,
                success: function (response) {
                    if (response) {
                        var url = pf.isMobile() ? response.mobEnrollURL : response.webEnrollURL;

                        url += "?info={EUID:" + response.lcGUID + ",FN:" + pf.session.get("FirstName") + ",LN:" + pf.session.get("LastName") + "}";
                        //url += "?info={EUID:" + response.lcGUID + ",FN:First Name,LN:Last Name}";
                        //window.open(url, "_blank");
                        location.assign(url);
                    }
                    else
                        jAlert("There was an error trying to add a card. Please try again")
                },
                error: function (response) {
                }
            });

            BaseView.prototype.initialize(this);
        },
        render: function () {
            this.$el.html(this.template({}));
            return this;
        },

        close: function () {
        }
    });
});

